import { render } from "./AddAdditionalNote.vue?vue&type=template&id=2e5b471b"
import script from "./AddAdditionalNote.vue?vue&type=script&lang=js"
export * from "./AddAdditionalNote.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/gradbeni-dnevnik/gradbeni-dnevnik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__